import {gql, useQuery} from '@apollo/client'
import {useStatesAndHealthConditions} from '../../../store/hooks/breadCrumbs'
import {getState} from '../../../shared/helpers/getState'
import {useFilterManagement} from '../../../store/hooks/useFilterManagement'
import {usePersona} from '../../../store/hooks/persona'

export default function useQueryPersonaByCounty() {
  const GET_PERSONA_BY_COUNTY = gql`
    query GetPersonaByCounty($filters: Filters, $benefits: [BenefitEligibility]) {
      countyPersona(filters: $filters, benefits: $benefits) {
        personaPerCounty {
          county
          state
          fips
          dominant_persona
          persona_cohort
          persona_population
          countyPercentage
          statePercentage
        }
        personaPercentage {
          persona
          percentage
          personaCount
        }
        personaPerState {
          state
          stateFips
          dominant_persona
          persona_cohort
          persona_population
          statePercentage
        }
        missingGeoIds
      }
    }
  `
  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const {filters} = useStatesAndHealthConditions()
  const {personas, personasToggle} = usePersona()

  const appliedFilterParams = getQueryParams()
  const selectedState = getState(filters)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []
  const selectedPersonas = personasToggle ? {persona: personas} : {}

  const {
    data: personaByCounty,
    loading: loadingPersonaByCounty,
    error: personaByCountyError,
    refetch: refetchPersonaByCounty
  } = useQuery(GET_PERSONA_BY_COUNTY, {
    variables: {
      filters: {
        ...appliedFilterParams,
        ...selectedPersonas,
        state: selectedState
      },
      benefits: benefitsData
    },
    skip: !personasToggle,
    fetchPolicy: 'cache-first'
  })

  return {
    personaByCounty,
    loadingPersonaByCounty,
    personaByCountyError,
    refetchPersonaByCounty
  }
}
